import { render, staticRenderFns } from "./asesores.vue?vue&type=template&id=8720244c"
import script from "./asesores.vue?vue&type=script&lang=js"
export * from "./asesores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports